import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  getLabel,
  getTimeLeft,
} from '@src/containers/VoiceLeaderboard/Header/PeriodSwitcher';
import { COLOR } from '@src/styles/color';
import Typography from '@src/new-components/Typography';
import { StyledSentences } from './index.style';

const LABELS = [
  { vi: 'Giờ', enSingular: 'Hour', enPlural: 'Hours', key: 'hours' },
  { vi: 'Phút', enSingular: 'Minute', enPlural: 'Minutes', key: 'minutes' },
  { vi: 'Giây', enSingular: 'Second', enPlural: 'Seconds', key: 'seconds' },
];

const View = ({
  isRecording,
  professionalSentence,
  isCountdown,
  showErrorMaxAttempts,
  lastTime,
  improveAudioUploadEnabled,
}) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const lastTimePlus24h = lastTime
    ? new Date(new Date(lastTime).getTime() + 24 * 60 * 60 * 1000)
    : null;
  const [timeLeft, setTimeLeft] = useState(getTimeLeft(lastTimePlus24h));

  useEffect(() => {
    const timer = setInterval(
      () => setTimeLeft(getTimeLeft(lastTimePlus24h)),
      1000,
    );
    return () => clearInterval(timer);
  }, [lastTime]);

  if (showErrorMaxAttempts) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          component="p"
          variant="body-16-medium"
          color={COLOR.textRejected}
        >
          {improveAudioUploadEnabled
            ? t('improveAudioUpload')
            : t('maxAttemptsReached')}
        </Typography>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Typography
            component="p"
            variant="body-14-regular"
            color={COLOR.descriptionUpload}
          >
            {t('tryAgainTime')}
          </Typography>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {LABELS.map(({ vi, enSingular, enPlural, key }) => (
              <div
                style={{ display: 'flex', alignItems: 'center', gap: '2px' }}
              >
                <Typography
                  variant="body-16-semibold"
                  color={COLOR.descriptionGray}
                  className="text-period-switcher"
                >
                  {String(timeLeft[key]).padStart(2, '0')}
                </Typography>
                <Typography
                  variant="body-14-regular"
                  color={COLOR.descriptionUpload}
                  style={{ display: 'flex', alignItems: 'center', gap: '2px' }}
                  className="text-period-switcher"
                >
                  {getLabel(timeLeft[key], vi, enSingular, enPlural, lang)}
                </Typography>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
  if (isCountdown) {
    return (
      <Typography
        component="span"
        variant="body-20-bold"
        color={COLOR.descriptionGray}
        style={{
          height: '44px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {t('getReadyToRead')}
      </Typography>
    );
  }
  if (isRecording) {
    return (
      <Typography component="p" variant="body-20-medium" color={COLOR.darkGray}>
        {professionalSentence?.originalText}
      </Typography>
    );
  }
  return (
    <Typography
      component="p"
      variant="body-20-medium"
      color={COLOR.darkGray}
      gutterBottom
    >
      {t('notReadyToRead')}
    </Typography>
  );
};

const Sentences = ({
  isCountdown,
  professionalSentence,
  isRecording,
  showErrorMaxAttempts,
  lastTime,
  improveAudioUploadEnabled,
}) => {
  const { t } = useTranslation();

  return (
    <StyledSentences>
      <div style={{ textAlign: 'center' }}>
        <Typography
          component="p"
          textTransform="uppercase"
          color={COLOR.descriptionUpload}
          variant="body-14-medium"
          style={{
            display: 'flex',
            alignItems: 'center',
            height: '40px',
            justifyContent: 'center',
            margin: '0 auto',
          }}
        >
          {t('verifyYourVoice')}
        </Typography>
      </div>
      <div style={{ marginTop: '24px' }}>
        <View
          isRecording={isRecording}
          professionalSentence={professionalSentence}
          isCountdown={isCountdown}
          showErrorMaxAttempts={showErrorMaxAttempts}
          lastTime={lastTime}
          improveAudioUploadEnabled={improveAudioUploadEnabled}
        />
      </div>
    </StyledSentences>
  );
};

export default Sentences;
